import type { Action } from 'svelte/action';

/**
 * Prende o Tab dentro do diálogo enquanto ele está aberto e devolve o foco a quem o abriu ao fechar.
 */
export const trapFocus: Action<HTMLElement> = (dialog) => {
  const focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;

  const focusables = (): HTMLElement[] => [...dialog.querySelectorAll<HTMLElement>(focusableSelector)];

  const keepTabInside = (event: KeyboardEvent): void => {
    if (event.key !== 'Tab') return;
    const all = focusables();
    const first = all.at(0);
    const last = all.at(-1);
    if (!first || !last) return;
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
      return;
    }
    if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  focusables().at(0)?.focus();
  dialog.addEventListener('keydown', keepTabInside);

  return {
    destroy() {
      dialog.removeEventListener('keydown', keepTabInside);
      opener?.focus();
    },
  };
};
